import { MenuIdProjects } from '@jira/navigation-apps__constants/src/MenuIdProjects.tsx';
import {
	getServiceDeskNavigationResources,
	getServicedeskPageContextResources,
} from '@jira/router-resources__service-desk-common/src/getServiceDeskSettingsResources.tsx';
import { servicedeskIssueTypesResource } from '@jira/router-resources__service-desk-issue-types/src/servicedeskIssueTypesResource.tsx';
import { slaMetricsDataResource } from '@jira/router-resources__service-desk-sla-settings/src/slaMetricsDataResource.tsx';
import ErrorPagesNotFound from '@jira/router-routes__common/src/ui/error-pages/not-found/index.tsx';
import { gettingStartedSlaEntryPoint } from '@jira/spa-apps__servicedesk-getting-started-page/src/gettingStartedSlaEntryPoint.entrypoint.tsx';
import { createPageEntryPoint } from '@jira/platform__routing-create-route-entry-point/src/index.tsx';
import { fg } from '@atlassian/jira-feature-gating';
import { staticProjectSidebarNavigationResource } from '@jira/navigation-apps__resources/src/controllers/sidebar/static-project-sidebar/index.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { servicedeskGettingStartedSlaEditRoute } from '@jira/router-routes__servicedesk-getting-started-page-routes/src/servicedeskGettingStartedSlaEditRoute.tsx';
import { serviceProjectLayout } from '@jira/platform__layouts-service-project-layout/src/index.tsx';
import { GettingStartedPageSkeleton } from '@jira/platform__skeletons/src/ui/getting-started-page/GettingStartedPageSkeleton.tsx';
import type { Route } from '@atlassian/react-resource-router';

const slaPageEntryPoint = createPageEntryPoint({
	main: gettingStartedSlaEntryPoint,
});

export const servicedeskGettingStartedSlaEditRouteEntry: Route = createEntry(
	servicedeskGettingStartedSlaEditRoute,
	() => ({
		group: 'servicedesk',
		layout: serviceProjectLayout,
		perfMetricKey: 'servicedesk-getting-started-sla-load',
		skeleton: GettingStartedPageSkeleton,

		navigation: {
			menuId: MenuIdProjects,
		},

		resources: [
			...getServiceDeskNavigationResources(),
			...getServicedeskPageContextResources(),
			staticProjectSidebarNavigationResource,
			servicedeskIssueTypesResource,
			slaMetricsDataResource,
		],

		entryPoint() {
			return fg('solution_composer_master') ? slaPageEntryPoint : undefined;
		},

		// eslint-disable-next-line no-restricted-syntax
		component: ErrorPagesNotFound,

		bifrost: {
			bifrostGroup: 'shell-only',
		},
	}),
);
